import { Wallet, FolderKanban, FileClock } from "lucide-react";
import { money } from "@/lib/format";
import { Card } from "@/components/ui-kit/Card";

export function DashboardMetrics({ metrics, funder }) {
  const o = metrics.outstanding;
  const need = metrics.matters_needing_action;

  return (
    <div className="grid gap-4 sm:grid-cols-3" data-testid="dashboard-metrics">
      <Card className="p-5" data-testid="metric-outstanding">
        <div className="flex items-center justify-between">
          <p className="text-xs uppercase tracking-wide text-muted-foreground">Total outstanding</p>
          <Wallet className="h-4 w-4 text-muted-foreground" />
        </div>
        <p className="mt-2 nums text-3xl font-semibold text-foreground" data-testid="metric-outstanding-total">{money(o.total)}</p>
        <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-xs text-muted-foreground">
          <span>Client <span className="nums font-medium text-foreground" data-testid="metric-outstanding-client">{money(o.client)}</span></span>
          <span>{funder.abbr} <span className="nums font-medium text-foreground" data-testid="metric-outstanding-funder">{money(o.funder)}</span></span>
        </div>
      </Card>

      <Card className="p-5" data-testid="metric-needs-action">
        <div className="flex items-center justify-between">
          <p className="text-xs uppercase tracking-wide text-muted-foreground">Matters needing action</p>
          <FolderKanban className="h-4 w-4 text-muted-foreground" />
        </div>
        <p className="mt-2 nums text-3xl font-semibold text-foreground" data-testid="metric-needs-action-count">{need}</p>
        <p className="mt-3 text-xs text-muted-foreground">{need === 1 ? "matter" : "matters"} with an open alert</p>
      </Card>

      <Card className="p-5" data-testid="metric-unbilled">
        <div className="flex items-center justify-between">
          <p className="text-xs uppercase tracking-wide text-muted-foreground">Unbilled work</p>
          <FileClock className="h-4 w-4 text-muted-foreground" />
        </div>
        <p className="mt-2 nums text-3xl font-semibold text-foreground" data-testid="metric-unbilled-total">{money(metrics.unbilled_work)}</p>
        <p className="mt-3 text-xs text-muted-foreground">approved, not yet invoiced</p>
      </Card>
    </div>
  );
}
